export enum PRODUCT_TYPE {
    request = 'ADS-REQUEST',
    advertisement = 'ADVERTISEMENT',
}

export enum ADVERTISEMENT_TYPE {
    Ready = 'READY',
    offPlanSale = 'OFF-PLAN-SALE'
}